module.exports = __webpack_public_path__ + "static/media/magnifying_glass.85bb89c5.svg";